import mensajeError  from "../../mensajes/MensajeError";
import { obtenerCatalogo } from "./obtenerCatalogo";

/**
 * Objeto de catalogos: Estados, Municipios, Trámites, Conceptos de pago, Estatus de poliza y Naciones
 * @param {Object} catalogos 
 * @param {Function} setCatalogos 
 * @param {Function} setDataLoaded 
 */
const obtenerCatalogos = async (catalogos, setCatalogos, setDataLoaded) => {
    try {
        var tramitesArray = [];
        const tramitesTest = await obtenerCatalogo("/api/tramite/lista", "Imposible obtener catálogo: Trámites");
        const conceptosTest = await obtenerCatalogo("/api/conceptopago/lista", "Imposible obtener catálogo: Conceptos de pago");
        for (let indexT = 0; indexT < tramitesTest.length; indexT++) {
            for (let indexC = 0; indexC < conceptosTest.length; indexC++) {
                if (tramitesTest[indexT].idTramite === conceptosTest[indexC].idTramite && conceptosTest[indexC].vigente === 1) {
                    tramitesArray.push(tramitesTest[indexT]);
                }
            }
        }
        var uniq = [...new Set(tramitesArray)].sort((a, b) => a.nombre.localeCompare(b.nombre));

        setCatalogos({
            ...catalogos,
            uma: { ...await obtenerCatalogo("/api/uma/lista", "Imposible obtener catálogo: UMA") },
            areas: [...await obtenerCatalogo("/api/area/lista", "Imposible obtener catálogo: Áreas")],
            estados: [...await obtenerCatalogo("/api/estado/lista", "Imposible obtener catálogo: Estados")],
            tramites: [...uniq],
            municipios: [...await obtenerCatalogo("/api/municipio/lista", "Imposible obtener catálogo: Municipios")],
            localidades: [...await obtenerCatalogo("/api/localidad/lista", "Imposible obtener catálogo: Localidades")],
            nacionalidad: [...await obtenerCatalogo("/api/nacionalidad/lista", "Imposible obtener catálogo: Localidades")],
            estatusPoliza: [...await obtenerCatalogo("/api/estatuspoliza/lista", "Imposible obtener catálogo: Estatus de póliza")],
            conceptoPagos: [...conceptosTest].sort((a, b) => a.descripcion.localeCompare(b.descripcion)).filter(item => item.vigente === 1),
            usuarios: [...await obtenerCatalogo("/api/usuario/lista", "Imposible obtener Lista de usuarios")],
            modalidades:[...await obtenerCatalogo("/api/modalidad/obtener", "Imposible obtener modalidades")],
            submodalidades:[...await obtenerCatalogo("/api/submodalidad/obtener", "Imposible obtener submodalidades")],
        });
        setDataLoaded(true);
    }
    catch (error) {
        mensajeError(error.message);
    }
}

export default obtenerCatalogos;
